<template>
	<Dialog
		v-model="showDialog"
		:title="'MFA验证'"
		:hide-cancel="true"
		:confirm-text="$t('login.verification')"
		@confirm="confirm"
	>
		<el-form :model="form" ref="ruleFormRef">
			<el-form-item>
				<p style="line-height: 1.7em">
					IPhone手机，打开 Google Authenticator；android手机，打开“谷歌身份验证器”或“ Google
					Authenticator”，输入显示的6位数字，每隔30秒变化一次
				</p>
			</el-form-item>
			<el-form-item
				prop="code"
				:rules="[
					{ required: true, message: $t('login.pl_code'), whitespace: true, trigger: 'change' },
				]"
			>
				<el-input v-model="form.code" :placeholder="'请输入6位验证码'" autocomplete="off" />
			</el-form-item>
		</el-form>
	</Dialog>
</template>

<script lang="ts" setup>
import { ref, watchEffect } from 'vue'
import Dialog from '/@/components/dialog/Dialog.vue'

const props = defineProps<{
	modelValue: boolean
}>()
const emits = defineEmits(['cancel', 'confirm', 'close', 'update:modelValue'])

const form = ref({
	code: '',
})
const showDialog = ref(props.modelValue)

watchEffect(() => {
	showDialog.value = props.modelValue
})

watchEffect(() => {
	emits('update:modelValue', showDialog.value)
})

const ruleFormRef = ref()
const confirm = () => {
	ruleFormRef.value.validate(async (valid) => {
		if (!valid) return
		emits('update:modelValue', false)
		emits('confirm', form.value.code)
	})
}
</script>

<style scoped lang="scss"></style>
